export const SAME_DAY_RECEIPT_ERROR_MGS =
  "Cash Deposition request can only be submitted for the same date receipts.";
